import * as React from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import _ from "lodash";

// Zustand store
import { useAppStore } from "../../stores";

// needed components
import AffiliateSearch from "../../components/SearchForms/AffiliateSearch/AffiliateSearch";
import PrivateRoute from "../../components/PrivateRoute/PrivateRoute";
import AffiliateSingleRecordDisplay from "./AffiliateSingleRecordDisplay";
import AffiliateSearchResults from "components/SearchForms/AffiliateSearch/AffiliateSearchResults";
import AttendeeSummary from "../AttendeeSummary/AttendeeSummary";

// import permissions
import { usertype_permissions } from "../../enums/PermissionEnums";

interface IAffiliateInfoRouterProps {}

const AffiliateInfoRouter: React.FC<IAffiliateInfoRouterProps> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Zustand store
  const authenticated = useAppStore((state) => state.authentication?.isLoginSuccess || false);
  const user = useAppStore((state) => state.user);

  // If we want to route directly off GUID for complaince, remove affiliatepres and designee from this
  const stateFedOrHigher =
    _.find(user.permissions, (permission: any) => {
      return (
        permission.name.indexOf(usertype_permissions.Admin) != -1 ||
        permission.name.indexOf(usertype_permissions.BackOffice) != -1 ||
        permission.name.indexOf(usertype_permissions.StateFed) != -1 ||
        permission.name.indexOf(usertype_permissions.Designee) != -1 ||
        permission.name.indexOf(usertype_permissions.AffiliatePresident) != -1
      );
    }) !== undefined;

  React.useEffect(() => {
    if (location.pathname === "/affiliate-info") {
      if (stateFedOrHigher) {
        navigate("/affiliate-info/search");
      } else {
        navigate("/affiliate-info/affiliate/" + user.user.affiliateGuid);
      }
    }
  });

  const onRowClickSearchResults = (data: any) => {
    if (data[0]) {
      navigate(`/affiliate-info/affiliate/${data[0].toString()}`);
    }
  };

  const onRowClickWhoIsAttendingTable = (data: any) => {
    if (data[0]) {
      navigate(`/affiliate-info/attendee-summary/${data[0]}`);
    }
  };

  return (
    <Routes>
      <Route
        path="search"
        element={
          <PrivateRoute>
            <AffiliateSearch />
          </PrivateRoute>
        }
      />
      <Route
        path="search-results"
        element={
          <PrivateRoute>
            <AffiliateSearchResults onRowClick={onRowClickSearchResults} />
          </PrivateRoute>
        }
      />
      <Route
        path="affiliate/:affiliateid"
        element={
          <PrivateRoute>
            <AffiliateSingleRecordDisplay onRowClick={onRowClickWhoIsAttendingTable} />
          </PrivateRoute>
        }
      />
      <Route
        path="attendee-summary/:attendeeid"
        element={
          <PrivateRoute>
            <AttendeeSummary />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default AffiliateInfoRouter;
